import { useGoodsRoute } from '../../../hooks/useGoodsRoute';
import { useMemo } from 'react';
import { useGoodsSno } from './useGoodsSno';
import { isNil, isNotNil } from 'shared/src/utils';

type PreRenderParams = {
  goods_name: string;
  market_name: string;
  cover_image: string;
  market_image: string;
  discount_rate: number;
  original_price: number;
  price: number;
  first_page_rendering?: string;
};

type PreRenderValues = {
  sno: number;
  name: string;
  market: {
    name: string;
  };
  cover_images: [string];
  price_info: {
    consumer: number;
    thumbnail_price: number;
    discount_rate: number;
  };
};
export const usePreRenderParams = () => {
  const { params } = useGoodsRoute<'GoodsDetail'>();
  const goodsSno = useGoodsSno();
  return useMemo<{ data: PreRenderValues | undefined }>(() => {
    if (params.extras) {
      const getItem = (): PreRenderParams | undefined => {
        try {
          const extras =
            typeof params.extras === 'string'
              ? JSON.parse(params.extras)
              : params.extras;

          if (isNotNil(extras.first_page_rendering)) {
            return JSON.parse(extras.first_page_rendering);
          }
          return extras;
          // first_page_rendering 이 잘못된 JSON(예: 공백이 `+`로 인코딩되어 온 딥링크)이면
          // pre-render 만 skip 하고 정상 로딩으로 폴백한다 (크래시 방지).
        } catch {
          return undefined;
        }
      };

      const item = getItem();
      if (isNil(item)) return { data: undefined };
      return {
        data: {
          sno: goodsSno,
          name: item.goods_name,
          market: {
            name: item.market_name,
          },
          cover_images: [item.cover_image],
          price_info: {
            consumer: item.original_price,
            thumbnail_price: item.price,
            discount_rate: item.discount_rate,
          },
        },
      };
    }
    return { data: undefined };
  }, [goodsSno, params.extras]);
};
